// extracted by mini-css-extract-plugin
export default {"reviewAttachment":"ReviewAttachment_reviewAttachment__+KBZu","fileInput":"ReviewAttachment_fileInput__V2mgK","filePreview":"ReviewAttachment_filePreview__F++xs"};